

import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';
import blueBanner from '../../ImageAssets/blueBanner.png';
import { setLoginPage, setForgetPasswordDetails } from '../../General/Actions';
import Background from '../../ImageAssets/blueskyBackground.png';
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';
import SignUpComponent from './SignUpComponent';
import { FaArrowLeft } from 'react-icons/fa';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Constants from '../../Utils/constants.json';

class ForgetPasswordOtpSentToNumberComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            phoneNumber: "",
            enteredOtpViaNumber: "",
            time: {
                "h": 0,
                "m": 0,
                "s": 0
            },
            seconds: Constants.otpTimer,
            isOtpTimerEnds: false,
            resendOtpClicked: false,
            resendOtpCount: 0
        }
        this.timer = 0
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.startTimer();
        this.maskPhoneNumber(this.props.forgetPasswordDetails.profileContactNumber);
    }

    secondsToTime = (secs) => {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer = () => {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown = () => {
        let seconds = this.state.seconds - 1;
        this.setState({ seconds: seconds });
        var element = document.getElementById("timer")
        if (typeof (element) != 'undefined' && element != null) {
            element.innerHTML = this.secondsToTime(seconds).m + ":" + this.secondsToTime(seconds).s + "s"
        }
        if (seconds == 0) {
            this.setState({ isOtpTimerEnds: true })
            clearInterval(this.timer);
        }
    }


    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    inputValueChange(name, value) {
        this.setState({ [name]: value })
    }

    loginButtonClicked() {
        window.location.reload();
    }

    maskPhoneNumber(myNumber) {
        var maskedPhoneNumber = "";
        var cleaned = ('' + myNumber).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{2})(\d{6})(\d{2})$/);
        if (match) {
            maskedPhoneNumber = [match[1], 'XXXXXX', match[3]].join('');
        }
        this.setState({
            phoneNumber: maskedPhoneNumber
        });
    }

    resendOtp() {
        var resendOtpCount = this.state.resendOtpCount + 1
        if (resendOtpCount <= 3) {
            this.timer = 0;
            this.setState({ resendOtpClicked: true })
            var generatedOtp = Math.floor(Math.random() * 90000) + 10000;
            var dataToSendForOtp = {
                otp: generatedOtp,
                contactNum: this.props.forgetPasswordDetails.profileContactNumber
            }
            this.setState({ isLoading: true })
            Network.executeAxios("otpAuth", "POST", dataToSendForOtp, (responseForOtp) => {
                this.setState({ isLoading: false })
                if (responseForOtp.result_code && responseForOtp.result_code === "0") {
                    this.setState({ isOtpTimerEnds: false, seconds: Constants.otpTimer })
                    var otpTimer = Constants.otpTimer * 1000
                    setTimeout(() => {
                        this.setState({ resendOtpClicked: false });
                    }, otpTimer);
                    this.startTimer();
                    this.props.setForgetPasswordDetails("generatedOtp", generatedOtp);
                } else {
                    Swal.fire(this.props.locales.internalErrorInForgetPwdPageSwal, "", "");
                }
            });
        }
        this.setState({ resendOtpCount: resendOtpCount })
    }

    submitNumberOtp() {
        var enteredOtpViaNumber = this.state.enteredOtpViaNumber;
        if (enteredOtpViaNumber == this.props.forgetPasswordDetails.generatedOtp) {
            this.props.changeCurrentForgetPasswordPartTo("changePassword");
        } else {
            Swal.fire(this.props.locales.otpNotMatchingInSwal, "", "");
        }
    }

    forgetPasswordOtpSentToEmailTryAnotherWay() {
        this.props.changeCurrentForgetPasswordPartTo("accountRecoveryFailed");
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const forgetPasswordOtpSentToEmailOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetPasswordOtpSentToEmailOuterMainContainerStyle}>
                <div className='p-5' style={{  backgroundImage: `url(${blueBanner})`,backgroundRepeat:"no-repeat",backgroundSize:"100% 100%"}}>
                        <div className='row pb-5' style={{}}>
                            <FaArrowLeft color="#fafafa" size="16" onClick={() => this.loginButtonClicked()} />
                            <img alt="" src={ApuaWhiteTextLogo} />
                        </div>
                    </div>
                <div className="row m-0 align-items-center justify-content-center" style={{ flex: 1, }}>
                    <div className="col-md-3 p-0 m-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center",}}>
                            {this.forgetPasswordOtpSentToNumberPart()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    forgetPasswordOtpSentToNumberPart() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0">
                {/* <div className="d-md-none col-md-12 p-0">
                    <div className="row col-md-12 m-auto py-2 px-2" style={{ backgroundColor: '#0285CA' }}>dfgd
                        <div className="col-md-12"><FaArrowLeft color="#fafafa" size="16" onClick={() => this.loginButtonClicked()} /> <img alt="" src={ApuaWhiteTextLogo} height="60" /></div>
                    </div>
                </div> */}
                <div className="col-md-12 row m-0 p-0">
                    <div className="col-md-12 pt-4 m-0 p-0 align-items-center justify-content-center" id="forgetPasswordOtpSentToNumberContainer">
                        <div className="col-md-12" style={{ fontSize: 30, color: '#404042', fontWeight: 400, textAlign:"center" }}>{this.props.locales.forgetPswpageForgetPswTxt}</div>
                        <div className="col-md-12 pt-2" style={{ fontSize: 16, color: '#404042', textAlign:"center" }}>{this.props.locales.otpSendToMobileNumInOtpText}</div>
                        <div className="col-md-12" style={{ fontSize: 16, color: '#404042', textAlign:"center" }}> <span style={{ fontWeight: 500 }}>{this.state.phoneNumber}</span></div>
                        <div className="col-md-12 text-center pb-2 pt-3" id="timer" style={{ fontWeight: 600, fontSize: 14 }}></div>
                        <div className="col-md-12 pb-3" >
                            <div className="col-12 row m-0 p-0">
                                <div className="form-group col-12 p-0">
                                    <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.forgetPswNumEnterOTPTxt}</label>
                                    <Input type="text" name="enteredOtpViaNumber" autoComplete="new-password" style={{ color: '#404042' }}
                                        className="loginCredItem input_data_ pt-4 pb-3" placeholder={this.props.locales.forgetPswNumEnterOTPPlc}
                                        onChange={(event) => this.inputValueChange("enteredOtpViaNumber", event.target.value)}
                                        onKeyUp={(event) => this.displayLabel(event, this.state.enteredOtpViaNumber, this.props.locales.forgetPswNumEnterOTPPlc)} />
                                    {this.state.isOtpTimerEnds && this.state.resendOtpClicked == false && this.state.resendOtpCount <= 3 ?
                                        <div className="errorDesc pt-1 text-left">{this.props.locales.otpExpiredMsgInOtpTimer}</div>
                                        : null}
                                    {this.state.resendOtpClicked ?
                                        <div className="errorDesc pt-1 text-left" style={{ color: '#36B07F' }}>{this.props.locales.newOtpSentMsgInOtpTimer}</div>
                                        : null}
                                    {this.state.resendOtpCount > 3 ?
                                        <div className="errorDesc pt-1 text-left">{this.props.locales.maxOtpReqReachedMsgInOtpTimer}</div>
                                        : null}

                                    <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-12 pt-4 d-flex align-items-center justify-content-center">
                            <Button className="loginPageLoginButton" disabled={this.state.enteredOtpViaNumber === "" || this.state.isOtpTimerEnds ? true : false} onClick={() => { this.submitNumberOtp() }}>
                                {this.props.locales.forgetPswNumVerifyBtn}
                            </Button>
                        </div>

                        <div className="d-flex pt-4 col-md-12 justify-content-center pb-3">
                            {this.state.isOtpTimerEnds ?
                                <div style={{ color: '#0285CA', fontSize: 16, fontWeight: 'bold', cursor: 'pointer' }} onClick={() => { this.resendOtp() }}>{this.props.locales.resendOtpInRegisterPart}</div>
                                :
                                <div style={{ fontWeight: 600, fontWeight: 'bold', color: '#0285CA', fontSize: 16, opacity: '0.5' }}>{this.props.locales.resendOtpInRegisterPart}</div>
                            }
                        </div>

                        <div className="d-flex pt-3 col-md-12 justify-content-center pb-5">
                            <div className='forgetLabel' onClick={() => { this.loginButtonClicked() }}>{this.props.locales.singInOptionTextInSignInWithOtpPart}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    loginPartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 p-0 row m-0 pt-5 pb-5" style={{ backgroundColor: '#000000', height: 'inherit', flex: 1 }}>
                <div className="col-md-1"></div>
                <div className="col-md-9 pl-5 pr-4 row mt-5 pt-5" style={{ flex: 1, alignItems: "center", justifyContent: "center", height: 'inherit' }}>
                    <div className="col-md-12 row " >
                        <div className="mb-1 col-md-12" style={{ fontSize: 35, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.forgetPswNumAlreadyHvAnAccTxt}</div>
                        <div className="mb-5 pb-4 col-md-12" style={{ fontSize: 16, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.forgetPswNumSignInHereTxt}</div>
                        <div className="col-md-12 pr-4">
                            <Button className="loginPageRegisterButton" style={{ fontSize: 24, fontWeight: 500 }} onClick={() => { this.loginButtonClicked() }}>
                                {this.props.locales.forgetPswNumSignInBtn}
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="col-md-2"></div>
            </div>
        )
    }

    displayLabel(event, value, placeHolderText) {
        if (value != "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }


}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        forgetPasswordDetails: state.forgetPasswordDetails
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        }
    }
}

const ForgetPasswordOtpSentToNumberComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgetPasswordOtpSentToNumberComponent)


export default ForgetPasswordOtpSentToNumberComponentContainer;
